import React, { useState } from 'react';
import { Drawer } from 'antd';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { LogoFull, Menu, CloseIcon, User, ChevronRight, ChevronLeft, HouseCertificate, EmailRound, CopyRound, TwitterRound, FacebookRound, LinkedinRound } from '../../assets/icons';
import './AccountNavMobile.scss';
import LogoutModal from '../LogoutModal/LogoutModal';
import { EmailShareButton, FacebookShareButton, LinkedinShareButton, TwitterShareButton } from 'react-share';
import { toastNotify } from '../../utils/toastNotify';
import { copyTextToClipboard } from '../../utils';
import { getReferralLink } from '../../services/authApi/authApi';

const AccountNavMobile = (props) => {
  const { setSideBarName } = props;
  const [open, setOpen] = useState(false);
  const [openAccountDrawer, setOpenAccountDrawer] = useState(false);
  const [openMarketDrawer, setOpenMarketDrawer] = useState(false);
  const [openReferalDrawer, setOpenReferalDrawer] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const userProfileData = useSelector((state) => state.userData.userData);
  const closeDrawer = () => {
    setOpen(false);
    setOpenAccountDrawer(false);
    setOpenMarketDrawer(false);
    setOpenReferalDrawer(false)
  };
  let referallink = localStorage.getItem('referralLink')
  const bodyText = `Check out Realbricks for hassle-free real estate investing! Get started today: `;

  const handleOnreferalClick = async () => {
    try {
      setOpenReferalDrawer(true)
      let link = localStorage.getItem('referralLink');
      if(!link) {
        const token = localStorage.getItem('access_token');
        link = await getReferralLink(token);
        localStorage.setItem('referralLink', link.data.referralLink);
      }
    } catch (error) {
      // Handle error
      console.error('Error fetching referral link:', error);
    }
  };

  return (
    <>
      <nav className='navmob'>
        <div className='navmob__logo'>
          <Link to='/'>
            <LogoFull color='#1a1519' />
          </Link>
        </div>
        <div className='navmob__ham' onClick={() => setOpen(true)}>
          <Menu />
        </div>
      </nav>
      <Drawer className='navdrawer' width={400} headerStyle={{ display: 'none' }} onClose={() => setOpen(false)} open={open}>
        <div className='mb-32 navmob'>
          <div className='navmob__logo'>
            <LogoFull />
          </div>
          <div className='navmob__ham' onClick={closeDrawer}>
            <CloseIcon size='30' />
          </div>
        </div>
        <ul className='navdrawer__list'>
          {!!Object.keys(userProfileData)?.length && localStorage.getItem('access_token') && (
            <li className='navdrawer__list__item' onClick={() => setOpenAccountDrawer(true)}>
              <span className='subhead-3'>
                <User size='20' color='#8A4743' verticalAlign='-4px' marginRight='5px' /> {`Hi, ${userProfileData?.firstName}`}
              </span>
              <ChevronRight />
            </li>
          )}
          {(!Object.keys(userProfileData)?.length || !localStorage.getItem('access_token')) && (
            <li className='navdrawer__list__item'>
              <Link to='/login' className='subhead-2'>
                Log in
              </Link>
            </li>
          )}
          {(!Object.keys(userProfileData)?.length || !localStorage.getItem('access_token')) && (
            <li className='navdrawer__list__item'>
              <Link to='/sign-upAuth' className='subhead-2'>
                Sign up
              </Link>
            </li>
          )}
          <li className='navdrawer__list__item' onClick={() => setOpenMarketDrawer(true)}>
            <span className='subhead-2'>Invest</span>
            <ChevronRight />
          </li>
          {!!Object.keys(userProfileData)?.length && (
            <li className='navdrawer__list__item'>
              <Link to='/portfolio' className='subhead-2'>
                Portfolio
              </Link>
            </li>
          )}
          <li className='navdrawer__list__item'>
            <a href='https://www.realbricks.com/learn' target='_self' className='subhead-2' rel='noreferrer'>
              Learn
            </a>
          </li>
          {!!Object.keys(userProfileData)?.length && (
            <li className='navdrawer__list__item'>
              <Link to='/marketplace/favorites' className='subhead-2'>
                Favorites
              </Link>
            </li>
          )}
          {!!Object.keys(userProfileData)?.length && (
            <li className='navdrawer__list__item' onClick={handleOnreferalClick}>
            <span className='subhead-2'>Referal</span>
            <ChevronRight />
          </li>
          )}
        </ul>
      </Drawer>
      <Drawer
        className='navdrawer'
        width={400}
        headerStyle={{ display: 'none' }}
        onClose={() => setOpenAccountDrawer(false)}
        open={openAccountDrawer}
      >
        <div className='account'>
          <div className='mb-32 navmob'>
            <div className='cursor-pointer text-terracotta fw-600 fz-16 navmb__back' onClick={() => setOpenAccountDrawer(false)}>
              <ChevronLeft marginRight='5px' verticalAlign='-6px' />
              Back
            </div>
            <div className='navmob__ham' onClick={closeDrawer}>
              <CloseIcon size='30' />
            </div>
          </div>
          <ul className='account__list'>
            <p className='subhead-2 text-taupe-80'>My Account</p>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Profile');
                }}
                to='/account'
              >
                Profile
              </Link>
            </li>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Balances & Transactions');
                }}
                to='/account/transactions'
              >
                Balances & Transactions
              </Link>
            </li>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Payment Methods');
                }}
                to='/account/payment'
              >
                Payment Methods
              </Link>
            </li>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Documents');
                }}
                to='/account/documents'
              >
                Documents
              </Link>
            </li>
            <li className='mb-32 account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Settings');
                }}
                to='/account/settings'
              >
                Settings
              </Link>
            </li>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Help Center');
                }}
                to='/account/help-center'
              >
                Help Center
              </Link>
            </li>
            <li className='account__list__item'>
              <Link
                onClick={() => {
                  closeDrawer();
                  setSideBarName('Legal');
                }}
                to='/account/legal'
              >
                Legal
              </Link>
            </li>
            <li className='account__list__item cursor-pointer' onClick={() => setLogoutModal(true)}>
              <span>Log out</span>
            </li>
          </ul>
        </div>
      </Drawer>
      <Drawer className='navdrawer' width={400} headerStyle={{ display: 'none' }} onClose={() => setOpenMarketDrawer(false)} open={openMarketDrawer}>
        <div className='market'>
          <div className='mb-32 navmob'>
            <div className='cursor-pointer text-terracotta fw-600 fz-16 navmb__back' onClick={() => setOpenMarketDrawer(false)}>
              <ChevronLeft marginRight='5px' verticalAlign='-6px' />
              Back
            </div>
            <div className='navmob__ham' onClick={closeDrawer}>
              <CloseIcon size='30' />
            </div>
          </div>
          <ul className='options'>
            <li className='options__item'>
              <HouseCertificate color='#8A4743' />
              <Link onClick={closeDrawer} to='/' className='text-almost-black subhead-3 mb-0'>
                All Properties
                <p className='text-taupe-80'>Start building your wealth with Realbricks’ fractionalized real estate assets.</p>
              </Link>
            </li>
            <li className='options__item'>
              <span></span>
              <Link onClick={closeDrawer} to='/marketplace/initial' className='text-almost-black subhead-3 mb-0'>
                Initial Offerings
                <p className='text-taupe-80'>Get in early with our hand-picked investements.</p>
              </Link>
            </li>
            <li className='options__item'>
              <span></span>
              <Link onClick={closeDrawer} to='/marketplace/secondary' className='text-almost-black subhead-3 mb-0'>
                Market
                <p className='text-taupe-80'>Purchase shares of available residential properties.</p>
              </Link>
            </li>
          </ul>
          <ul className='properties'>
            <li className='properties__item'>
              <span>PROPERTY TYPES</span>
            </li>
            <li className='properties__item'>
              <Link className='fz-16 text-almost-black fw-600' href='/vacation'>
                Vacation Rentals
              </Link>
            </li>
            <li className='properties__item'>
              <Link className='fz-16 text-almost-black fw-600' href='/longterm'>
                Long-term Rentals
              </Link>
            </li>
            <li className=' mb-20 properties__item'>
              <Link className='fz-16 text-almost-black fw-600' href='/multiunit'>
                Multi-unit
              </Link>
            </li>
            <li className='properties__item'>
              <span>STATUS</span>
            </li>
            <li className='properties__item'>
              <Link className='fz-16 text-almost-black fw-600' href='/leased'>
                Leased
              </Link>
            </li>
          </ul>
        </div>
      </Drawer>
      <Drawer className='navdrawer' width={400} headerStyle={{ display: 'none' }} onClose={() => setOpenReferalDrawer(false)} open={openReferalDrawer}>
      <div className='market'>
          <div className='mb-32 navmob'>
            <div className='cursor-pointer text-terracotta fw-600 fz-16 navmb__back' onClick={() => setOpenReferalDrawer(false)}>
              <ChevronLeft marginRight='5px' verticalAlign='-6px' />
              Back
            </div>
            <div className='navmob__ham' onClick={closeDrawer}>
              <CloseIcon size='30' />
            </div>
          </div>
          <div className='sharepop'>
      <p className='fz-14 mb-0 text-taupe-80'>Share to:</p>
      <TwitterShareButton className='d-flex g-8 align-items-center sharepop__item' url={`${bodyText} ${referallink}`}>
        <TwitterRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Share on Twitter</span>
      </TwitterShareButton>
      <FacebookShareButton url={localStorage.getItem('referralLink')} className='d-flex g-8 align-items-center sharepop__item'>
        <FacebookRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Share on Facebook</span>
      </FacebookShareButton>
      <LinkedinShareButton url={localStorage.getItem('referralLink')} className='d-flex g-8 align-items-center sharepop__item'>
        <LinkedinRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Share on LinkedIn</span>
      </LinkedinShareButton>
      <EmailShareButton
        url={`${bodyText}${localStorage.getItem('referralLink')}`}
        subject={'Real estate investment made easy'}
        // body={isHeader ? bodyText : window.location.href}
        className='d-flex g-8 align-items-center sharepop__item'
      >
        <EmailRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Send via email</span>
      </EmailShareButton>
      <a
        href={() => false}
        onClick={() => {
          copyTextToClipboard(localStorage.getItem('referralLink'));
          toastNotify('success', 'Link copied');
        }}
        className='d-flex g-8 align-items-center sharepop__item'
      >
        <CopyRound size={24} className='sharepop__item__logo' />
        <span className='sharepop__item__text'>Copy Link</span>
      </a>
    </div>
        </div>
      </Drawer>
      <LogoutModal logoutModal={logoutModal} setLogoutModal={setLogoutModal} onSuccess={closeDrawer} />
    </>
  );
};

export default AccountNavMobile;
